import http from '@/utils/http'

// 公共API
export default {
    // 总数据
    totalmanagement(data) {
        return http.get('/NewData/totalmanagement', data)
    },
    // 人数分布
    userdistribution(data) {
        return http.get('/NewData/userdistribution', data)
    },
    // 各中心业务量
    businessvolume(data) {
        return http.get('/NewData/businessvolume', data)
    },
    //   T-1人效
    humanefficiency(data) {
        return http.get('/NewData/humanefficiency', data)
    },
    // 签到率
    signrate(data) {
        return http.get('/NewData/signrate', data)
    },
    // 熟练度
    proficiencyrate(data) {
        return http.get('/NewData/proficiencyrate', data)
    },
    // 中心损益分析
    centerloss(data) {
        return http.get('/NewData/centerloss', data)
    },
    // 外包损益分析
    outsourcingloss(data) {
        return http.get('/NewData/outsourcingloss', data)
    }
}